import ApiValidationError from '@/errors/ApiValidationError';
import ApiAuthorizationError from '@/errors/ApiAuthorizationError';
import ApiUnhandledError from '@/errors/ApiUnhandledError';
import ApiExcessiveSignInError from '@/errors/ApiExcessiveSignInError';
import ApiValidationErrorModel from '@/models/errors/ApiValidationErrorModel';

export default class CashTamerApiBase {

    protected handleApiError(apiError: any): never {
        if ( apiError.response ) {
            if ( apiError.response.status === 400 ) {

                const apiValidationError = new ApiValidationError();

                if ( apiError.response.data.length > 0 ) {
                    const len: number = apiError.response.data.length - 1;

                    for (let i = 0; i <= len; i++ ) {
                        const validationError: ApiValidationErrorModel = new ApiValidationErrorModel();
                        validationError.errorCode = apiError.response.data[i].errorCode;
                        validationError.errorDescription = apiError.response.data[i].errorDescription;
                        apiValidationError.validationErrors.push(validationError);
                    }
                }

                throw apiValidationError;
            }
            else if ( apiError.response.status === 401 ) {
                throw new ApiAuthorizationError();
            }
            else if ( apiError.response.status === 429 ) {
                throw new ApiExcessiveSignInError();
            }

            // any other status codes will fall through to the throw at the bottom
        }

        throw new ApiUnhandledError();
    }

}
